var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3C97AA",
  fillRule: "evenodd",
  d: "M10.7 12 4 5.3 5.3 4l6.7 6.7L18.7 4 20 5.3 13.3 12l6.7 6.7-1.3 1.3-6.7-6.7L5.3 20 4 18.7l6.7-6.7Z",
  clipRule: "evenodd"
})));
export { SvgIcClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC43MDA1IDEyTDMuOTk5ODggNS4yOTkzNkw1LjI5OTI0IDRMMTEuOTk5OSAxMC43MDA2TDE4LjcwMDUgNEwxOS45OTk5IDUuMjk5MzZMMTMuMjk5MiAxMkwxOS45OTk5IDE4LjcwMDZMMTguNzAwNSAyMEwxMS45OTk5IDEzLjI5OTRMNS4yOTkyNCAyMEwzLjk5OTg4IDE4LjcwMDZMMTAuNzAwNSAxMloiIGZpbGw9IiMzQzk3QUEiLz4KPC9zdmc+Cg==";